import { createContext, useContext } from 'react';
export const SessionContext = createContext({ socket: null, room: null, liveId: null });
export const useSession = () => useContext(SessionContext);